<template>
  <TableLayout :permissions="['business:shopcomment:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="评论内容" prop="content">
        <el-input v-model="searchForm.content" placeholder="请输入评论内容" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="用户昵称" prop="nikeName">
        <el-input v-model="searchForm.nikeName" placeholder="请输入用户昵称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="店铺名称" prop="shopName">
        <el-input v-model="searchForm.shopName" placeholder="请输入店铺名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <!-- <ul class="toolbar" v-permissions="['business:shopcomment:delete']">
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:shopcomment:delete']">删除</el-button></li>
      </ul> -->
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="nikeName" label="用户昵称" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="content" label="评论内容" align="center" min-width="100px"></el-table-column>
        <el-table-column label="图片/视频" align="center" width="180px">
          <template slot-scope="{row}">
            <el-image
              style="width: 50px; height: 50px;"
              v-for="(item, index) in row.fileList"
              :key="index"
              :src="item.fileFullUrl"
              :initial-index="index"
              :preview-src-list="row.fileList.map(item => item.fileFullUrl)"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column prop="score" label="门店评分" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="envScore" label="店内环境" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="serviceScore" label="服务态度" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="shopName" label="店铺名称" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="评论时间" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="是否展示" align="center" min-width="100px">
          <template slot-scope="{row}">
            <el-switch
              v-model="row.status"
              active-color="#13ce66"
              :active-value="0"
              :inactive-value="1"
              @change="statusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import { updateById } from '@/api/business/shopComment'
export default {
  name: 'ShopComment',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        nikeName: '',
        content: '',
        shopName: '',
        // createDate: '',
        // editor: '',
        // editDate: '',
        // isdeleted: '',
        // remark: '',
        // objId: '',
        // score: '',
        // content: '',
        // anonymous: '',
        // envScore: '',
        // serviceScore: '',
        // menuIds: '',
        // status: '',
        // statusDate: '',
        // statusInfo: '',
        // statusId: '',
        // sortnum: '',
        // type: ''
      }
    }
  },
  created () {
    this.config({
      module: '商家评论管理信息表',
      api: '/business/shopComment',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    statusChange(row) {
      updateById(row)
        .then(res => {
          this.$message.success('操作成功')
        })
        .catch(e => {
          this.$message.error(e)
        })
        .finally(() => {
          this.search()
        })
    }
  },
}
</script>
